export default __webpack_public_path__ + "static/media/btn-cerrar.8a315bed.svg";